import { ApolloQueryResult } from '@apollo/client';
import { FetchNativeProductCatalogueWithOfferingAndPricingPlansQuery } from '@css-xp/graphtypes/src/generated-types-sxp';
import { PPCFeatureFlagKeys, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';

export enum ProductStatus {
  NEW = 'PURCHASE',
  EDITED = 'CHANGE',
  TRANSFER = 'TRANSFER',
  CANCEL = 'TO BE CANCELLED',
}

export enum OperationType {
  OWN = 'OWN',
  TRANSFER = 'TRANSFER',
  NEW = 'NEW',
}

export enum LinkedEntitlementRelationShipType {
  ADD_ON = 'ADD_ON',
  APP = 'APP',
  COLLECTION_INSTANCE = 'COLLECTION_INSTANCE',
}

export enum CloudSiteTypeEnum {
  OWN = 'OWN',
  NEW = 'NEW',
  EXTERNAL = 'EXTERNAL', // EXTERNAL: Which is required to identify products and apps that are not part of the current customer cloud site
}

export enum SelectType {
  SITE = 'site',
  ORG = 'org',
  ENTITLEMENT = 'entitlement',
}

export enum EnrichmentStatus {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export interface ChargeQuantity {
  chargeElement: string;
  quantity: number;
}

export enum CartPromotionAction {
  ADD_APP_PROMOTION = 'ADD_APP_PROMOTION',
  REMOVE_APP_PROMOTION = 'REMOVE_APP_PROMOTION',
  REMOVE_PRODUCT_PROMOTION = 'REMOVE_PRODUCT_PROMOTION',
}

export enum PromotionTypes {
  PARTNER_DISCOUNT = 'PARTNER_DISCOUNT',
  DISCRETIONARY_DISCOUNT = 'DISCRETIONARY_DISCOUNT',
}

export enum ORDER_PAGE_SIDEBAR {
  INCLUDED_PRODUCTS = 'included-products',
}

export type NativeProductResponse = ApolloQueryResult<FetchNativeProductCatalogueWithOfferingAndPricingPlansQuery>;

type FeatureFlagKey = keyof typeof PPCFeatureFlagKeys;
type StatsigFeatureFlagKey = keyof typeof STATSIG_FEATURE_GATES;
type StatsigFeatureFlagValue = typeof STATSIG_FEATURE_GATES[StatsigFeatureFlagKey];
type FeatureFlagValue = typeof PPCFeatureFlagKeys[FeatureFlagKey] | StatsigFeatureFlagValue;
export type FeatureFlags = Partial<Record<FeatureFlagValue, boolean>>;

export enum partnerMarginAPIStatus {
  ACCEPTED = 'ACCEPTED',
  IGNORED = 'IGNORED',
  FAILED = 'FAILED',
  INELIGIBLE = 'INELIGIBLE',
}

export enum partnerMarginProcessingStatus {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  PROCESSED = 'PROCESSED',
  TERMINATED = 'TERMINATED',
  IGNORED = 'IGNORED',
}
